import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './jobseeker/rtl.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeTheme } from './jobseeker/themePreference';

initializeTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

reportWebVitals();
